// extracted by mini-css-extract-plugin
export default {"app":"d6WLOcTu","body":"JLN5i4WD","content":"oTD3O5TQ","tabPanel":"HeNRmMzy"};